document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sale-countdown-wrapper").forEach(wrapper => {
    const startDate = new Date(wrapper.dataset.saleStart).getTime();

    const daysEl = wrapper.querySelector(".days");
    const hoursEl = wrapper.querySelector(".hours");
    const minutesEl = wrapper.querySelector(".minutes");
    const secondsEl = wrapper.querySelector(".seconds");

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = startDate - now;

      // When the sale start then hide the countdown
      if (distance <= 0) {
        wrapper.style.display = "none";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      daysEl.textContent = days;
      hoursEl.textContent = hours.toString().padStart(2, "0");
      minutesEl.textContent = minutes.toString().padStart(2, "0");
      secondsEl.textContent = seconds.toString().padStart(2, "0");
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
